import React from "react";
import { Button, Select } from "antd";
import { PlusOutlined, SearchOutlined, AppstoreOutlined, UnorderedListOutlined } from "@ant-design/icons";
import { GUIDED_JOURNEY_TARGET } from "../../../config/guidedJourneyConfig";
import { HUB_STORES } from "../../../config/zinihubConfig";
import styles from "./HubHeader.module.css";

const HubHeader = React.memo(function HubHeader({
  searchQuery,
  onSearchChange,
  hubProfiles,
  selectedHubId,
  onHubChange,
  viewMode,
  onViewModeChange,
  sortBy,
  onSortChange,
  onCreateBusiness,
  createBusinessDisabled,
  createBusinessDisabledReason,
}) {
  return (
    <div className={styles.header}>
      <div className={styles.titleRow}>
        <h1 className={styles.title}>My Hub</h1>
        <p className={styles.subtitle}>Manage all businesses from one place.</p>
      </div>

      <div className={styles.controls}>
        <div className={styles.searchWrapper}>
          <SearchOutlined className={styles.searchIcon} />
          <input
            type="text"
            className={styles.searchInput}
            placeholder="Search businesses..."
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
            aria-label="Search businesses"
          />
        </div>

        {hubProfiles.length > 0 && (
          <Select
            value={selectedHubId}
            onChange={onHubChange}
            placeholder="Hub"
            className={styles.hubSelect}
            options={hubProfiles.map((profile) => ({
              value: profile?.PK,
              label: profile?.DisplayName || profile?.Domain,
            }))}
            showSearch
            optionFilterProp="label"
            size="large"
          />
        )}

        <Select
          value={sortBy}
          onChange={onSortChange}
          className={styles.sortSelect}
          options={[
            { value: "name", label: "Name" },
            { value: "recent", label: "Recently Edited" },
            { value: "created", label: "Created" },
          ]}
          size="large"
        />

        <div className={styles.viewToggle} role="radiogroup" aria-label="View mode">
          <button
            className={`${styles.viewBtn} ${viewMode === "grid" ? styles.viewBtnActive : ""}`}
            onClick={() => onViewModeChange("grid")}
            aria-label="Grid view"
            aria-pressed={viewMode === "grid"}
          >
            <AppstoreOutlined />
          </button>
          <button
            className={`${styles.viewBtn} ${viewMode === "list" ? styles.viewBtnActive : ""}`}
            onClick={() => onViewModeChange("list")}
            aria-label="List view"
            aria-pressed={viewMode === "list"}
          >
            <UnorderedListOutlined />
          </button>
        </div>

        <Button
          id={GUIDED_JOURNEY_TARGET.CREATE_BUSINESS}
          type="primary"
          size="large"
          icon={<PlusOutlined />}
          className={styles.createBusinessBtn}
          onClick={onCreateBusiness}
          disabled={createBusinessDisabled}
          title={createBusinessDisabledReason || undefined}
        >
          {HUB_STORES.CREATE_BUSINESS}
        </Button>
      </div>
    </div>
  );
});

export default HubHeader;
